import React from "react";
import { PortfolioGrid } from "../../Components";
import { Box, Heading, Text } from "@chakra-ui/react";

const Portfolio = () => {
  return (
    <Box id="portfolio" mt="40px">
      <Heading
        as="h2"
        fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
        // mb="8"
        textAlign={{ base: "center", md: "left" }}
      >
        See my Work
      </Heading>
      <Text fontSize="lg" mb={8}>
        Here are some of the designs that i have done
      </Text>
      <Box>
        <PortfolioGrid />
      </Box>
    </Box>
  );
};

export default Portfolio;
